import { useNavigate } from "react-router-dom";
import { useAuth } from "@/auth/useAuth";
import { Button } from "@/components/ui/button";
import { ArrowLeft, LogOut } from "lucide-react";
import type { ReactNode } from "react";

interface Props {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  showBack?: boolean;
}

export function PageHeader({ title: _title, subtitle, actions, showBack = true }: Props) {
  const navigate = useNavigate();
  const { user, signOut } = useAuth();
  return (
    <header className="border-b border-border" style={{ backgroundColor: "rgb(0, 56, 130)" }}>
      <div className="container mx-auto flex items-center justify-between py-5 px-4">
        <div
          className="flex items-center gap-4 cursor-pointer"
          onClick={() => navigate("/")}
        >
          <img
            src="/Logo JC Azul.png"
            alt="JusCapital"
            className="h-10 w-auto"
          />
          <div>
            {subtitle && (
              <p className="text-xs" style={{ color: "rgba(255,255,255,0.7)" }}>{subtitle}</p>
            )}
          </div>
        </div>
        <div className="flex items-center gap-3">
          <span className="text-sm hidden sm:inline" style={{ color: "rgba(255,255,255,0.7)" }}>
            {user?.email}
          </span>
          {showBack && (
            <Button
              variant="ghost"
              size="sm"
              onClick={() => navigate(-1)}
              className="gap-2"
              style={{ color: "white" }}
            >
              <ArrowLeft className="h-4 w-4" /> Back
            </Button>
          )}
          {actions}
          <Button variant="ghost" size="icon" onClick={() => signOut()} title="Sign out" style={{ color: "white" }}>
            <LogOut className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </header>
  );
}
